import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { enterpriseTokens } from "styles/theme";

const DashboardPanelHeader = ({ eyebrow = "Performance insight", title, subtitle, action }) => (
    <Box sx={{ px: 1.5, py: 1.25, borderBottom: `1px solid ${enterpriseTokens.lineSoft}`, backgroundColor: "#FBFCFE", display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", md: "center" }, gap: 2 }}>
        <Box>
            <Chip label={eyebrow} size="small" sx={{ mb: 0.5, height: 19, borderRadius: "999px", bgcolor: enterpriseTokens.primarySoft, color: enterpriseTokens.primaryDark, fontWeight: 600, fontSize: "9px", textTransform: "uppercase" }} />
            <Typography sx={{ fontSize: "12px", lineHeight: "20px", fontWeight: 600, color: enterpriseTokens.navy }}>{title}</Typography>
            {subtitle && <Typography sx={{ mt: 0.25, fontSize: "11px", lineHeight: "16px", fontWeight: 500, color: enterpriseTokens.muted }}>{subtitle}</Typography>}
        </Box>
        {action && <Stack direction="row" alignItems="center">{action}</Stack>}
    </Box>
);

export default DashboardPanelHeader;
